









































































































































import Vue from "vue";
import { storage } from "@/plugins/firebase-kiosk";
import { db } from "@/plugins/firebase";
import { AuthenticationService } from "@/services/authenticationService";
import { KioskConfigurationService } from "@/services/KioskConfigurationService";
import ThemePreview from "@/components/KioskConfiguration/ThemePreview.vue";

import vueFilePond from "vue-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";
import { log } from "util";

const FilePond = vueFilePond(
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  FilePondPluginFileValidateType,
  FilePondPluginFilePoster,
  FilePondPluginFileEncode
);

function Process(
  fieldName: string,
  file: File,
  metadata,
  load: (id: string) => void,
  error: (error: string) => void,
  progress: (computable: boolean, loaded: number, total: number) => void,
  abort: () => void,
  transfer,
  options,
  field: string
) {
  const storageRef = storage.ref().child(`kioskConfiguration/${field}`);
  const uploadTask = storageRef.put(file);
  uploadTask.on(
    "state_changed",
    (snapshot) => {
      progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
    },
    (e) => {
      // tslint:disable-next-line:no-console
      console.error(e);
      error(e.message);
    },
    async () => {
      // Handle successful uploads on complete
      try {
        const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
        if (field.includes("Banner")) {
          const bannerIndex = Number(field.split(/([0-9]+)/)[1]) - 1;
          await KioskConfigurationService.UpdateSetting(`ThemeSettings.BackgroundPhotos.Banners.${bannerIndex}`, downloadURL);
        } else {
          await KioskConfigurationService.UpdateSetting(`ThemeSettings.BackgroundPhotos.${field}`, downloadURL);
        }
        load(downloadURL);
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error(e);
        error(e.message);
      }
    }
  );
  return {
    abort: () => {
      uploadTask.cancel();
      abort();
    },
  };
}

export default Vue.extend({
  data() {
    return {
      companyId: AuthenticationService.getCompanyId(),
      initialFiles: {} as any,
      configurationData: null as any,
      unsubscribe: null as any,
      selectedFileUrl: "",
      previewImageModal: false,
      server: (field: string) => ({
        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
          Process(fieldName, file, metadata, load, error, progress, abort, transfer, options, field);
        },
        async remove(file, success, error) {
          try {
            if (field.includes("Banner")) {
              const bannerIndex = Number(field.split(/([0-9]+)/)[1]) - 1;
              await KioskConfigurationService.UpdateSetting(`ThemeSettings.BackgroundPhotos.Banners.${bannerIndex}`, "");
            }
            else{
              await KioskConfigurationService.UpdateSetting(`ThemeSettings.BackgroundPhotos.${field}`, "");
            }
          } catch (e) {
            error(e);
            return;
          }
          success();
        },
      }),
      colors: {
        PrimaryBackground: "#ffffff",
        PrimaryForeground: "#ffffff",
        SecondaryBackground: "#ffffff",
        SecondaryForeground: "#ffffff",
        SelectedCategoryBackground: "#ffffff",
        SelectedCategoryForeGround: "#ffffff",
        SidebarBackground: "#ffffff",
        TertiaryBackground: "#ffffff",
        TertiaryForeground: "#ffffff",
        ValidationForeground: "#ffffff",
        BodyBackground: "#ffffff",
        IntroBackground: "#C4161C",
        ItemNameForeground: "727272",
        ItemPriceForeground: "727272",
      },
      fonts: {
        Button: "Futura PT Medium",
        Category: "Futura PT Medium",
        ConfirmationText: "Futura PT Bold",
        Heading: "Futura PT Bold",
        Item: "Futura PT Bold",
        Payment: "Futura PT Book",
        Pricing: "Intro Bold Regular",
        SubHeading: "Futura PT Medium",
        Total: "Intro Bold Regular",
      },
      uiSettings: {
        DoubleRowBackground: false,
        MenuColumnsCount: 3,
      },
      backgroundPhotos: {
        IdleVideo: "",
        NoImage: "",
        AddtocartLogo: "",
        Common: "",
        CommonLogo: "",
        Menu: "",
        SideBarLogo: "",
        Sidebar: "",
        Intro: "",
        Signin: "",
        Banners: Object,
        Banner1: "",
        Banner2: "",
        Banner3: "",
      },
      savingColors: false,
      savingFonts: false,
      savingUiSettings: false,
      fontValues: [
        "Futura PT Bold",
        "Futura PT Medium",
        "Futura PT Book",
        "Intro Bold Regular",
        "Intro Regular Regular",
        "Open Sans",
        "Montserrat SemiBold",
      ],
    };
  },
  components: {
    FilePond,
    ThemePreview,
  },
  created() {
    this.unsubscribe = db
      .collection("OnlineOrderingModule")
      .doc(this.companyId)
      .onSnapshot((doc) => {
        this.$set(this, "configurationData", doc.data());
      });
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  watch: {
    configurationData() {
      if (this.configurationData && this.configurationData.ThemeSettings) {
        if (this.configurationData.ThemeSettings.Colours) {
          this.colors = { ...this.colors, ...this.configurationData.ThemeSettings.Colours };
        }
        if (this.configurationData.ThemeSettings.Fonts) {
          this.fonts = { ...this.fonts, ...this.configurationData.ThemeSettings.Fonts };
        }
        if (this.configurationData.ThemeSettings.UiSettings) {
          this.uiSettings = { ...this.uiSettings, ...this.configurationData.ThemeSettings.UiSettings };
        }
        if (this.configurationData.ThemeSettings.BackgroundPhotos) {
          this.backgroundPhotos = { ...this.backgroundPhotos, ...this.configurationData.ThemeSettings.BackgroundPhotos };
          const banners = Object.entries(this.backgroundPhotos.Banners);
          this.setBanners(banners);
          for (const key in this.backgroundPhotos) {
            if (this.backgroundPhotos[key]) {
              if (!(this.initialFiles[key] && this.initialFiles[key].length && this.initialFiles[key][0].source.url == this.backgroundPhotos[key])) {
                const fileObject = {
                  source: { id: Date.now(), url: this.backgroundPhotos[key] },
                  options: {
                    type: "local",
                    file: {
                      name: this.backgroundPhotos[key],
                    },
                    metadata: {
                      poster: this.backgroundPhotos[key],
                    },
                  },
                };
                if (this.initialFiles[key] && this.initialFiles[key].length) {
                  this.$set(this.initialFiles[key], 0, fileObject);
                } else {
                  this.initialFiles[key] = [fileObject];
                }
              }
            } else {
              this.initialFiles[key] = [];
            }
          }
        }
      }
    },
  },
  computed: {
    colorKeys(): any {
      return Object.keys(this.colors);
    },
    fontKeys(): any {
      return Object.keys(this.fonts);
    },
    backgroundPhotoKeys(): any {
      return Object.keys(this.backgroundPhotos);
    },
  },
  methods: {
    setBanners(banners) {
      try {
        this.backgroundPhotos.Banner1 = banners[0][1];
        this.backgroundPhotos.Banner2 = banners[1][1];
        this.backgroundPhotos.Banner3 = banners[2][1];
      } catch (error) {
        return;
      }
    },
    async saveColors() {
      try {
        this.savingColors = true;
        await KioskConfigurationService.UpdateSetting(`ThemeSettings.Colours`, JSON.stringify(this.colors));
        this.notyfy.success("Saved Successfully");
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.savingColors = false;
      }
    },
    async saveFonts() {
      try {
        this.savingFonts = true;
        await KioskConfigurationService.UpdateSetting(`ThemeSettings.Fonts`, JSON.stringify(this.fonts));
        this.notyfy.success("Saved Successfully");
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.savingFonts = false;
      }
    },
    async saveUiSettings() {
      try {
        this.savingUiSettings = true;
        await KioskConfigurationService.UpdateSetting(`ThemeSettings.UiSettings`, JSON.stringify(this.uiSettings));
        this.notyfy.success("Saved Successfully");
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.savingUiSettings = false;
      }
    },
    handleSwitchChange(e, prop) {
      this.$set(this, prop, e.checked);
    },
    checkMenuColumnsCount() {
      if (this.uiSettings.MenuColumnsCount < 2) {
        this.uiSettings.MenuColumnsCount = 2;
      } else if (this.uiSettings.MenuColumnsCount > 3) {
        this.uiSettings.MenuColumnsCount = 3;
      }
    },
    handleAddfile(err, file, backgroundPhotoKey) {
      if (!err && file && file.status == 2) {
        this.$set(this.backgroundPhotos, backgroundPhotoKey, file.getFileEncodeDataURL());
      }
    },
    handleActivatefile(file) {
      this.selectedFileUrl = file.source.url;
      this.previewImageModal = true;
    },
  },
});
